const EN_US = {
    COUNTRY_CODE: 'US',
    ID: 'en-us',
    NUMBER_FORMAT: {
        CURRENCY_DESCRIPTION: 'Dollar',
        CURRENCY_SYMBOL: '$',
        DECIMAL_SEPARATOR: '.',
        GROUP_SEPARATOR: ',',
    },
};
export { EN_US, };
//# sourceMappingURL=en-us.js.map